import styled from "styled-components";
import { UseFormRegisterReturn } from "react-hook-form";

interface StyledInputProps extends UseFormRegisterReturn {
  error?: boolean;
}

export default styled.input<StyledInputProps>`
  padding: 12px 16px;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ error }) => (error ? "#ff0000" : "#ffffff")};
  border-radius: 8px;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: #676767;
  box-shadow: ${({ error }) =>
    error
      ? "0px 0px 20px 6px rgba(140, 29, 29, 0.21)"
      : "0px 0px 20px 6px rgba(13, 51, 32, 0.15)"};

  &:focus {
    border-color: ${({ error }) => (error ? "#ff0000" : "#474747")};
  }

  &::placeholder {
    font-size: 14px;
    color: #a8a8a8;
  }
`;
